/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { CoreStrictHttpResponse } from '../../core-strict-http-response';
import { CoreRequestBuilder } from '../../core-request-builder';

import { CoreExternalCostResponseDto } from '../../models/core-external-cost-response-dto';

export interface ExternalCostsControllerFindByUserId$Params {

/**
 * Tenant identifier
 */
  tenant: string;

/**
 * User identifier
 */
  userId: string;
}

export function externalCostsControllerFindByUserId(http: HttpClient, rootUrl: string, params: ExternalCostsControllerFindByUserId$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<Array<CoreExternalCostResponseDto>>> {
  const rb = new CoreRequestBuilder(rootUrl, externalCostsControllerFindByUserId.PATH, 'get');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.path('userId', params.userId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as CoreStrictHttpResponse<Array<CoreExternalCostResponseDto>>;
    })
  );
}

externalCostsControllerFindByUserId.PATH = '/o2-core/external-costs/{tenant}/user/{userId}';
